// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"49f784ef","239":"2bf8d8a8","453":"06158cdc","667":"c38c873e"}[chunkId] + ".chunk.js";
};